<template>
  <div
    :class="b({done: task.questStatus})"
    @click="handleAction"
  >
    <div :class="b('checkbox', [taskClassModify])">
      <i class="zkicon iconjicheng-yiqiyong"></i>
    </div>
    <div
      v-overflow-tooltip="title"
      :class="b('title')"
    >
      {{ title }}
    </div>
    <el-button
      :class="b('action')"
      type="plaintext"
    >
      {{ actionButtonInfo.button }}
      <i class="zkicon iconyoujian"></i>
    </el-button>
  </div>
</template>
<script>
import theme from '@zk/theme/lib/variables.scss';
import { resolveUrl } from '@zk/framework-vue';
const permissionList = ['INTEGRATE_FEISHU', 'INTEGRATE_WECHAT', 'INTEGRATE_JENKINS', 'CHECK_INTEGRATION', 'CHECK_JIRA_IMPORT', 'CHECK_API_MANAGE', 'CHECK_API_MANAGE'];
import { guideUpdateStatus } from '@/api/guide';
import HighLightMenuDriver from './HighLightMenuDriver';
import { mapActions, mapGetters, mapState } from 'vuex';
import { sleep } from '@/utils';
import createIssueGif from '@/assets/guide/createIssue.gif';
import filterTaskGif from '@/assets/guide/filterTask.gif';
import * as permission from 'common-module/src/config/permission';
export default {
  name:'LightMenuItem',
  bemNS: theme.bemNS,
  mixins: [HighLightMenuDriver],
  inject: ['appLayout'],
  props: {
    task: {
      type: Object,
      required: true
    },
    integrateStatusMap: {
      type: Object,
      required: true
    },
    finishNum:{
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    getDefaultProject: {
      type: Function,
      required: true
    },
    currentProjectIsPersonal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDoing: false
    };
  },
  computed: {
    ...mapGetters('user', ['checkAccessPermission']),
    ...mapGetters('app', ['checkMenuVisible']),
    ...mapState('sprint', ['sprintList']),
    taskClassModify(){
      return this.task.questStatus ? 'done' : this.isDoing ? 'doing' : '';
    },
    projectInnerPage() {
      return ['kanban', 'backlog', 'automation', 'epic', 'work'];
    },
    isLarkConfig(){
      return this.checkAccessPermission(permission.integrationFeiShu) && !this.integrateStatusMap.lark;
    },
    isWechatConfig(){
      return this.checkAccessPermission(permission.integrationWechat) && !this.integrateStatusMap.weCom;
    },
    isJenkinsConfig(){
      return this.checkAccessPermission(permission.integrationJenkins) && !this.integrateStatusMap.jenkins;
    },
    isIntegrationConfig() {
      return this.checkAccessPermission(permission.integration);
    },
    isJiraConfig() {
      return this.checkAccessPermission(permission.systemImport);
    },
    isApiConfig() {
      return this.checkAccessPermission(permission.mgrApi);
    },
    isProjectPermission() {
      return this.checkAccessPermission(permission.automationPage);
    },
    title(){
      if (this.actionButtonInfo.isConfig) {
        return this.task.questName;
      }
      return this.actionButtonInfo.title ? this.actionButtonInfo.title : this.task.questName;
    },
    //需处理特殊情况（1、没打开开关，如史诗，2、自定义菜单没打开）
    checkMenuMap() {
      return {
        '/dashboard': {
          featureSwitch: true,
          customMenu: this.checkMenuVisible('dashboard')
        },
        '/team': {
          featureSwitch: true,
          customMenu: this.checkMenuVisible('team')
        },
        '/roadmap': {
          featureSwitch: true,
          customMenu: this.checkMenuVisible('roadmap')
        },
        '/backlog/list': {
          featureSwitch: this.$store.getters['features/isCurrentProjectSwitch']?.('module_sprint_switch'),
          customMenu: this.checkMenuVisible('backlog'),
          featureName: this.$t('backlog.Sprint'),
          routeName: '规划迭代'
        },
        '/work/table': {
          featureSwitch: true,
          customMenu: this.checkMenuVisible('work_list')
        },
        '/work/list': {
          featureSwitch: true,
          customMenu: this.checkMenuVisible('work_list')
        },
        '/epic/list': {
          featureSwitch: this.$store.getters['features/isCurrentProjectSwitch']?.('module_epic_switch'),
          customMenu: this.checkMenuVisible('epic'),
          featureName: this.$t('epic.epic'),
          routeName: '史诗列表'
        },
        '/release': {
          featureSwitch: this.$store.getters['features/isSwitch']('function_version_switch'),
          customMenu: this.checkMenuVisible('version')
        },
        '/project/automation': {
          featureSwitch: this.isProjectPermission,
          customMenu: true,
          i18nWarnKey: 'guide.task.noOpenAutomationPermission'
        }
      };
    },
    actionMap(){
      return {
        INTEGRATE_FEISHU: {
          scene:  '配置飞书集成',
          button:  this.isLarkConfig ? this.$t('guide.task.goSetting') : this.$t('guide.task.toView'),
          action: 'open',
          isConfig: this.isLarkConfig,
          title:this.$t('guide.action.larkBind'),
          url: `${this.$config.VUE_APP_PMS_URL}/setting/integration/lark`,
          document: this.$config.getDocUrl('SETTING_INTEGRATION_LARK_USED')
        },
        CREATE_ISSUE: {
          scene: '创建工作',
          button: this.$t('guide.task.toCreate'),
          action: 'startGuiding'
        },
        INTEGRATE_WECHAT: {
          scene: '配置企微集成',
          isConfig: this.isWechatConfig,
          title: this.$t('guide.action.weChatBind'),
          button: this.isWechatConfig ? this.$t('guide.task.goSetting') : this.$t('guide.task.toView'),
          action: 'open',
          url: `${this.$config.VUE_APP_PMS_URL}/setting/integration/we-com`,
          document: this.$config.getDocUrl('SETTING_INTEGRATION_WECOM_USED')
        },
        INVITE_MEMBERS: {
          scene: '邀请成员',
          button: this.$t('guide.task.toInvite'),
          action: 'startGuiding'
        },
        INTEGRATE_JENKINS: {
          scene: '配置Jenkins集成',
          button: this.isJenkinsConfig ? this.$t('guide.task.goSetting') : this.$t('guide.task.toView'),
          isConfig: this.isJenkinsConfig,
          action: 'open',
          title:this.$t('guide.action.jenkinsBind'),
          url: `${this.$config.VUE_APP_PMS_URL}/setting/integration/jenkins`,
          document: this.$config.getDocUrl('SETTING_INTEGRATION_JENKINS')
        },
        CHECK_ROADMAP: {
          scene: '查看路线图',
          button: this.$t('guide.task.toView'),
          route: '/roadmap',
          action: 'startGuiding',
          startWithHighlightMenu: true,
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.roadmap.title')])
        },
        CONFIG_AUTOMATIC_ROUTINE: {
          scene: '了解智能助理',
          button: this.$t('guide.task.toView'),
          action: 'startGuiding',
          route: '/project/automation',
          startWithHighlightMenu: true,
          isProjectInnerPage: true,
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.IntelligentAssistant.head')])
        },
        CHECK_EPIC: {
          scene: this.$t('guide.task.view', [this.appLayout.isShowGanttMenu ? this.$t('route.gantt') : this.$t('route.Epic')]),
          button: this.$t('guide.task.toView'),
          route: '/epic/list',
          action: 'startGuiding',
          startWithHighlightMenu: true,
          isProjectInnerPage: true,
          title: this.$t('guide.task.view', [this.appLayout.isShowGanttMenu ? this.$t('route.gantt') : this.$t('route.Epic')]),
          driverTitle: this.$t('guide.task.enter', [this.appLayout.isShowGanttMenu ? this.$t('route.gantt') : this.$t('route.Epic')])
        },
        CONFIG_DEV_PROCESS_PANEL: {
          scene: '配置一个开发进度仪表盘',
          button: this.$t('guide.task.toView'),
          action: 'createBoard',
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.Dashboard.head')])
        },
        LEARN_SCENARIOS: {
          scene: '了解推荐场景',
          button: this.$t('guide.task.moreInfo'),
          action: 'openScene'
        },
        CONFIG_BUG_SUMMARY_PANEL: {
          scene: '配置一个缺陷汇总仪表盘',
          button: this.$t('guide.task.toView'),
          action: 'createBoard',
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.Dashboard.head')])
        },
        CREATE_PROJECT: {
          scene: '创建项目',
          button: this.$t('guide.task.toCreate'),
          action: 'startGuiding'
        },
        CONFIG_MY_TASKS_PANEL: {
          scene: '配置一个我的工作仪表盘',
          button: this.$t('guide.task.toView'),
          action: 'createBoard',
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.Dashboard.head')])
        },
        CHECK_TEAM_VIEW: {
          scene: '查看团队',
          button: this.$t('guide.task.toView'),
          route: '/team',
          driverTitle: this.$t('guide.task.enter', [this.$t('navbar.teams')]),
          action: 'startGuiding',
          startWithHighlightMenu: true
        },
        CREATE_PERSONAL_PROJECT: {
          scene: '创建个人项目',
          button: this.$t('guide.task.toCreate'),
          action: 'startGuiding'
        },
        CHECK_IDE_PLUGIN: {
          scene: '查看IDE插件',
          button: this.$t('guide.task.toView'),
          action: 'open',
          document:'https://ligai.cn/integrations?isWeb=1'
        },
        FILTER_MY_TASKS: {
          scene: '筛选我要做的工作',
          button: this.$t('guide.task.toFilter'),
          action: 'startGuiding',
          router: '/kanban/list',
          query:{ guide:true }
        },
        CHECK_DASHBOARD: {
          scene: '了解仪表盘',
          button: this.$t('guide.task.toView'),
          route: '/dashboard',
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.Dashboard.head')]),
          action: 'startGuiding',
          startWithHighlightMenu: true
        },
        CHECK_VERSION: {
          scene: '进入版本',
          button: this.$t('guide.task.toView'),
          route: '/release',
          driverTitle: this.$t('guide.task.enter', [this.$t('route.release')]),
          action: 'startGuiding',
          startWithHighlightMenu: true,
          document: this.$config.getDocUrl('VERSION_FEATURES')
        },
        CHECK_KANBAN: {
          scene: '进入跟进迭代',
          button: this.$t('guide.task.toView'),
          action: 'startGuiding',
          driverTitle: this.$t('guide.task.enter', [this.appLayout.showSprintMenu ? this.$t('route.sprint_track') : this.$t('route.Kanban')]),
          route: '/kanban/list',
          isProjectInnerPage: true,
          startWithHighlightMenu: true
        },
        CHECK_BACKLOG: {
          scene: '进入规划迭代',
          button: this.$t('guide.task.toView'),
          action: 'startGuiding',
          driverTitle: this.$t('guide.task.enter', [this.$t('route.Backlog')]),
          route: '/backlog/list',
          isProjectInnerPage: true,
          startWithHighlightMenu: true
        },
        CHECK_WORK_LIST: {
          scene: '进入工作列表',
          button: this.$t('guide.task.toView'),
          action: 'startGuiding',
          driverTitle: this.$t('guide.task.enter', [this.$t('route.Issues')]),
          route: this.appLayout.isWorkListToAirtable ? '/work/table' : '/work/list',
          isProjectInnerPage: true,
          startWithHighlightMenu: true
        },
        CHECK_AUTOMATIC: {
          scene: '了解智能助理',
          button: this.$t('guide.task.toView'),
          action: 'startGuiding',
          route: '/project/automation',
          startWithHighlightMenu: true,
          isProjectInnerPage: true,
          driverTitle: this.$t('guide.task.enter', [this.$t('guide.IntelligentAssistant.head')])
        },
        CHECK_INTEGRATION: {
          scene:  '了解如何集成',
          button:  this.$t('guide.task.toView'),
          action: 'open',
          isConfig: this.isIntegrationConfig,
          url: `${this.$config.VUE_APP_PMS_URL}/setting/integration`,
          document: this.$config.getDocUrl('APP_AND_INTEGRATION')
        },
        CHECK_JIRA_IMPORT: {
          scene:  '了解jira导入',
          button:  this.$t('guide.task.toView'),
          action: 'open',
          isConfig: this.isJiraConfig,
          url: `${this.$config.VUE_APP_PMS_URL}/setting/import`,
          document: this.$config.getDocUrl('SETTING_INTEGRATION_JIRA_IMPORT')
        },
        CHECK_API_MANAGE: {
          scene:  '了解OpenAPI',
          button:  this.$t('guide.task.toView'),
          action: 'open',
          isConfig: this.isApiConfig,
          url: `${this.$config.VUE_APP_PMS_URL}/setting/api`,
          document: '/setting/api-key'
        }
      };
    },
    ...mapGetters('features', ['isSwitch']),
    actionButtonInfo(){
      return this.actionMap[this.task.questCode] || {};
    },
    currentIsProjectInnerPage(){
      return this.appLayout.showHeader;
    }
  },
  methods: {
    ...mapActions('app', ['changeProject']),
    isGuideEnd(){
      this.isDoing = false;
      guideUpdateStatus(this.task.id, 10);
      this.$set(this.task, 'questStatus', true);
    },
    createDashboardEnd(){
      this.beforeHighlightMenu('dashboard', this.actionButtonInfo.driverTitle);
      setTimeout(() => {
        this.isGuideEnd();
      }, 300);
    },
    async checkoutDefaultProject(){
      const p = this.getDefaultProject();
      await this.changeProject({
        id: p?.id,
        trackInfo: {
          id: p.id,
          pname: p.pname,
          eventGroupCode: 'list'
        }
      });
      await this.$store.dispatch('app/refreshProjectList');
      this.eventBus.$emit('updateNavProjectList');
    },
    async jumpToProject(){
      await this.checkoutDefaultProject();
      if (!this.currentIsProjectInnerPage){
        this.$router.push('/kanban/list');
      }
      await sleep(10);
    },
    //处理跳转的特殊情况（1、没打开开关，如史诗，2、自定义菜单没打开）
    handleSpecialCase(isOpenFeatureSwitch, isOpenCustomMenu){
      if (!isOpenFeatureSwitch) {
        this.isGuideEnd();
        if (this.actionButtonInfo.document) {
          return window.open(this.actionButtonInfo.document, '_blank');
        }
        const feature = this.checkMenuMap[this.actionButtonInfo.route]?.featureName;
        const routeName = this.checkMenuMap[this.actionButtonInfo.route]?.routeName;
        const i18nWarnKey = this.checkMenuMap[this.actionButtonInfo.route]?.i18nWarnKey;
        return this.$message.warning(this.$t(i18nWarnKey ? i18nWarnKey : 'guide.task.noOpenFeatureSwitch', {
          feature, routeName
        }));
      }
      if (!isOpenCustomMenu) {
        this.isGuideEnd();
        return window.open(resolveUrl(`${this.$config.VUE_APP_PMS_URL}${this.actionButtonInfo.route}?closeMask=true`));
      }
    },
    async handleAction(){
      this.actionStartTime = +new Date();
      this.$nextTick(() => {
        if (!this.task.questStatus) {
          this.$track.send('UG_ClickTask', { task_name: this.task.questName, task_order: this.index + 1, click_order: this.finishNum + 1 }, true);
        }
      });
      this.isDoing = true;
      if (this.actionButtonInfo.action === 'createBoard') {
        //仪表盘自定义菜单不存在的话需打开一个新页面
        if (!this.checkMenuMap['/dashboard'].customMenu) {
          return window.open(resolveUrl(`${this.$config.VUE_APP_PMS_URL}/dashboard?closeMask=true&action=createBoard&templateId=${this.task.extend}`));
        }
        this.createBoard(this.task.extend);
        this.$emit('action', this.createDashboardEnd);
        return;
      }
      if (permissionList.includes(this.task.questCode)) {
        //是否跳转到配置
        this.isGuideEnd();
        if (this.actionButtonInfo.isConfig){
          window.open(resolveUrl(this.actionButtonInfo.url));
          return;
        }
        window.open(this.actionButtonInfo.document);
        return;
      }
      if (this.actionButtonInfo.action === 'startGuiding') {
        if (this.actionButtonInfo.startWithHighlightMenu) {

          const routeInfos = this.actionButtonInfo.route.split('/');
          const routeName = routeInfos[routeInfos.length - 1];
          const isProjectInnerPage = this.actionButtonInfo.isProjectInnerPage;

          //处理跳转的特殊情况（1、没打开开关，如史诗，2、自定义菜单没打开）
          const isOpenFeatureSwitch = this.checkMenuMap[this.actionButtonInfo.route]?.featureSwitch ?? true;
          const isOpenCustomMenu = this.checkMenuMap[this.actionButtonInfo.route]?.customMenu ?? true;

          if (!isProjectInnerPage) {
            if (!isOpenFeatureSwitch || !isOpenCustomMenu) {
              this.handleSpecialCase(isOpenFeatureSwitch, isOpenCustomMenu);
              return;
            }
            this.beforeHighlightMenu(routeName, this.actionButtonInfo.driverTitle);
            return;
          }
          await this.jumpToProject();
          await sleep(10);
          if (!isOpenFeatureSwitch || !isOpenCustomMenu) {
            this.handleSpecialCase(isOpenFeatureSwitch, isOpenCustomMenu);
            return;
          }
          if (this.actionButtonInfo.route === '/epic/list') {
            this.beforeHighlightMenu('epic', this.actionButtonInfo.driverTitle);
            return;
          }
          if (this.actionButtonInfo.route === '/kanban/list') {
            this.beforeHighlightMenu('kanban', this.actionButtonInfo.driverTitle);
            return;
          }
          if (this.actionButtonInfo.route === '/backlog/list') {
            this.beforeHighlightMenu('backlog', this.actionButtonInfo.driverTitle);
            return;
          }
          if (this.actionButtonInfo.route === '/work/list' || this.actionButtonInfo.route === '/work/table') {
            this.beforeHighlightMenu('work', this.actionButtonInfo.driverTitle);
            return;
          }
          if (this.actionButtonInfo.route === '/project/automation') {
            this.beforeHighlightMenu('automation', this.actionButtonInfo.driverTitle);
            return;
          }

        } else {
          this.$emit('action', this.isGuideEnd);
          //项目特殊处理
          if (['CREATE_PROJECT', 'CREATE_PERSONAL_PROJECT'].includes(this.task.questCode)){
            if (this.$store.state.app.projectList.some(item=>!item.archived && item.recentVisit)) {
              this.eventBus.$emit('open-project-menu', true);
              this.beforeHighlightMenu('more-project', this.$t('guide.task.createProject1'));
              return;
            }
            this.$router.push({ path: '/project/list' });
            await sleep(10);
            this.beforeHighlightMenu('add-project', this.$t('guide.task.createProject2'));
            return;
          }
          //创建工作
          if (this.task.questCode === 'CREATE_ISSUE'){
            await this.jumpToProject();
            await sleep(10);
            this.$router.push({ path: '/kanban/list' });
            await sleep(10);
            this.beforeHighlightMenu('createIssue', `<div class="driver-content-create-issue">
              <div>${this.$t('guide.task.createIssue')}</div>
              <img src="${createIssueGif}">
            </div>`);
            return;
          }
          //邀请成员
          if (this.task.questCode === 'INVITE_MEMBERS'){
            this.beforeHighlightMenu('inviteMember', this.$t('guide.task.inviteMember'));
            return;
          }
          //筛选工作
          if (this.task.questCode === 'FILTER_MY_TASKS'){
            await this.jumpToProject();
            await sleep(10);
            this.$router.push({ path: '/kanban/list' });
            await sleep(10);
            //项目没有迭代的话 toast提示创建迭代 看板项目继续指引
            const sprintSwitch = this.$store.getters['features/isCurrentProjectSwitch']('module_sprint_switch');
            if (!this.sprintList?.length && sprintSwitch) {
              return this.$message.warning(this.$t('guide.task.createSprintFilterTask'));
            }
            this.beforeHighlightMenu('filterTask', `<div class="driver-content-filter-task">
              <div>${this.$t('guide.task.filterTask')}</div>
              <img src="${filterTaskGif}">
            </div>`);
            return;
          }
          window.console.warn('not startGuiding', this.task.questCode);
        }
        return;
      }
      if (this.actionButtonInfo.action === 'openScene'){
        this.eventBus.$emit('showVideo-highlights');
        this.isGuideEnd();
        return;
      }
      if (this.actionButtonInfo.action === 'open'){
        window.open(this.actionButtonInfo.document);
        this.isGuideEnd();
        return;
      }
    },
    createBoard(templateId){
      this.$emit('createBoard', templateId);
    },
    async awaitDomPrepare(cls){
      // eslint-disable-next-line
      while (true) {
        // eslint-disable-next-line no-await-in-loop
        await sleep(30);
        const dom = document.querySelector(cls);
        if (dom) {
          return dom;
        }
      }
    },
    async getMenuDom(routeName){
      if (routeName === 'epic' && this.appLayout.isShowGanttMenu) {
        const res = await this.awaitDomPrepare('[data-type="gantt"]');
        return res?.children[0]?.children[0];
      }
      if (routeName === 'kanban') {
        const res = await this.awaitDomPrepare('[data-type="kanban"]');
        return res?.children[0]?.children[0];
      }
      if (routeName === 'backlog') {
        const res = await this.awaitDomPrepare('[data-type="backlog"]');
        return res?.children[0]?.children[0];
      }
      if (routeName === 'work') {
        const cls = this.appLayout.isWorkListToAirtable ? 'issue-airtable' : 'issue-list';
        const res = await this.awaitDomPrepare(`[data-type="${cls}"]`);
        return res?.children[0]?.children[0];
      }
      if (routeName === 'epic') {
        const res = await this.awaitDomPrepare('[data-type="epic-list"]');
        return res?.children[0]?.children[0];
      }
      if (routeName === 'automation') {
        return await this.awaitDomPrepare('.top-nav-automation');
      }
      if (routeName === 'add-project') {
        return await this.awaitDomPrepare('.project-list-create-card');
      }
      if (routeName === 'createIssue') {
        return document.querySelector('.zk-float-add-btn__wrapper');
      }
      if (routeName === 'inviteMember') {
        return document.querySelector('.zk-left-aside__invite');
      }
      if (routeName === 'filterTask') {
        // return await this.awaitDomPrepare('.zk-confirm-dropdown');
        return await this.awaitDomPrepare('.zk-common-filter-top-index__main');
      }
      const dom = await this.awaitDomPrepare(`[data-menu="${routeName}"]`);
      return dom?.children[0];
    },
    getMenuOptions(routeName){
      let position = 'right-center';
      let menuClass = '.zk-left-menu-item__content';
      if (['epic', 'kanban', 'backlog', 'work'].includes(routeName)) {
        menuClass = '.zk-more-item .el-row';
        position = 'bottom-center';
      }
      if (routeName === 'automation') {
        menuClass = '.top-nav-automation';
        position = 'bottom-right';
      }
      if (routeName === 'add-project') {
        menuClass = '.project-list-create-card';
      }
      if (routeName === 'createIssue') {
        menuClass = '.zk-float-add-btn__wrapper';
        position = 'top-right';
      }
      if (routeName === 'inviteMember') {
        menuClass = '.zk-left-aside__invite';
        position = 'top-left';
      }
      if (routeName === 'filterTask') {
        menuClass = '.zk-confirm-dropdown';
        // position = 'left-top';
        position = 'bottom-center';
      }
      return {
        menuClass,
        position
      };
    },
    async beforeHighlightMenu(routeName, driverTitle){
      let menuDom = await this.getMenuDom(routeName);
      const { position, menuClass } = this.getMenuOptions(routeName);
      const isToProjectInnerPage = this.projectInnerPage.includes(routeName);
      let nextAction = null;
      if (isToProjectInnerPage) {
        await this.jumpToProject();
        if (!menuDom) {
          const delayTime = 1000 - (+new Date() - this.actionStartTime);
          await sleep(Math.max(delayTime, 0));
          menuDom = await this.getMenuDom(routeName);
        }
      }
      if (routeName === 'more-project') {
        nextAction = () => {
          setTimeout(() => {
            menuDom = document.querySelector('.project-list-drawer-create');
            this.highlightMenu(menuDom, this.$t('guide.task.createProject'), 'top-center', '.project-list-drawer-create', `${routeName}-2`);
          }, 800);
        };
      }

      this.eventBus.$emit('driver-show');
      this.highlightMenu(menuDom, driverTitle, position, menuClass, routeName, nextAction);
    }
  }
};
</script>
<style lang="scss" scoped>
@include b(light-menu-item) {
  position: relative;
  height: 40px;
  align-items: center;
  line-height: 40px;
  display: flex;
  padding-left: 16px;
  padding-right: 16px;
  cursor: pointer;
  &:hover{
    background: var(--gray-transparent-hover);
  }
  @include m(done) {
    color: var(--font-color-2);
  }
  @include e(checkbox){
    width: 16px;
    height: 16px;
    border: 0.8px solid rgba(183, 175, 245, 1);
    border-radius: 50%;
    margin-right: 12px;
    .zkicon{
      display: none;
      font-size: 12px;
      color: rgba(99, 96, 230, 1);
      transform:scale(0.5) translateX(-1px);
    }
    @include m(doing){
      border-color: rgba(99, 96, 230, 1);
      outline: 2px solid rgba(183, 175, 245, 1);
    }
    @include m(done){
      // background: rgba(236, 232, 255, 1);
      background: var(--state-done-bg);
      border-color: var(--state-done-bg);
      // border-color: rgba(236, 232, 255, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      .zkicon{
        display: inline-block;
        color: var(--state-done-color-1);
      }
    }
  }
  @include e(title){
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
  }
  @include e(action){
    display: none;
    ::v-deep{
      .el-button--content{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .zkicon{
          margin-left: 6px;
        }
      }
    }
  }
  &:hover{
    @include e(action){
      display: block;
    }
  }
}
</style>
<style lang="scss">
.driver-content-create-issue{
  font-size: 18px;
  line-height: 26px;
  img{
    margin-top: 12px;
    width: 400px;
    // height: 172px;
    height: 201px;
    border-radius: 6px;
    float: left;
  }
}
.driver-content-filter-task{
  font-size: 18px;
  line-height: 26px;
  img{
    margin-top: 12px;
    width: 276px;
    border-radius: 6px;
    float: left;
    // height: 309px;
  }
}
</style>
